module.exports = __webpack_public_path__ + "static/media/My Rank.eacfe425.png";